import setFilters from 'store/reducer-utils/setFilters'
import { updateObject } from 'utils/updateObject'
import {
  RESET_FILTERS,
  RESET_WALLET_TRANSACTIONS,
  RESET_WALLETS,
  SET_ACTIVE_WALLET_ID,
  SET_PROMISED_PAYMENTS,
  SET_WALLET_TRANSACTIONS,
  SET_WALLETS,
  SET_FILTERS,
} from 'modules/Finance/Wallets/types'

const initialState = {
  activeWalletID: null,
  filters: null,
  wallets: {
    loading: false,
    loaded: false,
    loadFailed: false,
    data: [],
  },
  transactions: {
    data: [],
    loaded: false,
    loading: false,
    pagination: {
      offset: 0,
      limit: 8,
      total: 0,
    },
    categories: {},
  },
  promisedPayments: {
    loading: false,
    loaded: false,
    loadFailed: false,
    data: {},
  },
}

const setWallets = (state, action) => ({
  ...state,
  wallets: {
    ...state.wallets,
    ...action.payload,
  },
})

const resetWallets = () => ({
  ...initialState,
})

const setWalletTransactions = (state, action) => ({
  ...state,
  transactions: {
    ...state.transactions,
    ...action.payload,
  },
})

const resetWalletTransactions = (state) => ({
  ...state,
  transactions: {
    ...initialState.transactions,
  },
})

const setPromisedPayments = (state, action) => ({
  ...state,
  promisedPayments: {
    ...state.promisedPayments,
    ...action.payload,
  },
})

const setActiveWalletID = (state, action) => ({
  ...state,
  activeWalletID: action.payload,
})

const setWalletFilters = (state, action, force = false) => {
  const filteredPayload =
    state?.filters && !force
      ? [...action.payload].filter(
          (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
        )
      : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const resetWalletFilters = (state, action) => updateObject(state, { filters: action.payload })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WALLETS:
      return setWallets(state, action)
    case RESET_WALLETS:
      return resetWallets(state)
    case RESET_FILTERS:
      return resetWalletFilters(state, action)
    case SET_FILTERS:
      return setWalletFilters(state, action)
    case SET_WALLET_TRANSACTIONS:
      return setWalletTransactions(state, action)
    case RESET_WALLET_TRANSACTIONS:
      return resetWalletTransactions(state)
    case SET_ACTIVE_WALLET_ID:
      return setActiveWalletID(state, action)
    case SET_PROMISED_PAYMENTS:
      return setPromisedPayments(state, action)

    default:
      return state
  }
}

export default reducer
